import dayjs from 'dayjs';
import { USER_ROLES } from '../../../Pages/Roles/index.js';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { apiRequests } from '../../../shared/api/apiRequests.js';
import { dateToString } from '../../../shared/utils/parseDate.js';
import { Link } from 'react-router-dom';
import { formatImageUrl } from '../../../shared/utils/formatImageUrl';
import { useStore } from '../../../shared/stores/context.js';
import { useEffect, useMemo, useState } from 'react';
import { axiosInstance } from '../../../shared/api/axiosInstance.js';
import { BanUserModal } from '../../../features/BanUserModal';
import { toast } from 'react-toastify';

export const User = ({ data, onUpdate }) => {
  const [avatar, setAvatar] = useState('');
  const [showBanModal, setShowBanModal] = useState(false);
  const { userStore } = useStore();
  console.log(data, USER_ROLES);
  const getRole = (id) => USER_ROLES.find((i) => i.id === data.roleModel.role).name;

  const handleBan = () => {
    setShowBanModal(true);
  };

  const handleUnban = () => {
    apiRequests.users
      .unban(data.id)
      .then(() => {
        toast.success('Пользователь успешно разблокирован');
        onUpdate();
      })
      .catch(() => {
        toast.error('Ошибка при разблокировке пользователя');
      });
  };

  useEffect(() => {
    if (userStore.user?.avatarPath) {
      axiosInstance
        .get(formatImageUrl(userStore.user.avatarPath), {
          responseType: 'blob',
          headers: { 'Content-Type': 'image/png' },
        })
        .catch((res) => {
          if (res && res.size && res.type) {
            setAvatar(URL.createObjectURL(res));
          }
        });
    }
  }, [userStore.user]);

  return (
    <div className="page-table-element">
      <div className="left">
        <div
          className="page-table-image border"
          style={{
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundImage: `url(${data?.avatarPath ? formatImageUrl(data.avatarPath) : `https://ui-avatars.com/api/?name=${data.name[0]}&color=7F9CF5&background=EBF4FF`})`,
          }}
        ></div>
        <div className="page-table-var-user">
          <div className="name">
            {data.name} {data.surname}
          </div>
          <div className="email">{data.email}</div>
        </div>
      </div>

      <div className="right">
        <div className="page-table-var">
          <div className="name">Роль</div>
          <div className="var">{getRole(data.roleModel.role)}</div>
        </div>

        <div className="page-table-var">
          <div className="name">Дата регистрации</div>
          <div className="var">{dateToString(data.createdAt)}</div>
        </div>

        <div className="actions">
          <Link to={`${window.location.pathname}/${data.id}`} className="action edit">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.204 10.796L19 9C19.5453 8.45475 19.8179 8.18213 19.9636 7.88803C20.2409 7.32848 20.2409 6.67152 19.9636 6.11197C19.8179 5.81788 19.5453 5.54525 19 5C18.4548 4.45475 18.1821 4.18213 17.888 4.03639C17.3285 3.75911 16.6715 3.75911 16.112 4.03639C15.8179 4.18213 15.5453 4.45475 15 5L13.1814 6.81866C14.1452 8.46926 15.5314 9.84482 17.204 10.796ZM11.7269 8.27311L4.8564 15.1436C4.43134 15.5687 4.21881 15.7812 4.07907 16.0423C3.93934 16.3034 3.88039 16.5981 3.7625 17.1876L3.1471 20.2646C3.08058 20.5972 3.04732 20.7635 3.14193 20.8581C3.23654 20.9527 3.40284 20.9194 3.73545 20.8529L6.81243 20.2375C7.40189 20.1196 7.69661 20.0607 7.95771 19.9209C8.21881 19.7812 8.43134 19.5687 8.8564 19.1436L15.7458 12.2542C14.1241 11.2386 12.7524 9.87627 11.7269 8.27311Z"
                fill="#198754"
              />
            </svg>
          </Link>

          <OverlayTrigger
            placement="left-start"
            overlay={
              <Tooltip id="button-tooltip">
                {userStore.user.id === data.id
                  ? 'Это вы'
                  : data.banInfo
                    ? 'Разблокировать'
                    : 'Заблокировать'}
              </Tooltip>
            }
          >
            {data.banInfo ? (
              <button
                disabled={userStore.user.id === data.id}
                onClick={handleUnban}
                className="action unban"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <circle cx="12" cy="12" r="9" stroke="#198754" strokeWidth="2" />
                  <path d="M18 18L6 6" stroke="#198754" strokeWidth="2" />
                </svg>
              </button>
            ) : (
              <button
                disabled={userStore.user.id === data.id}
                onClick={handleBan}
                className="action remove"
              >
                <svg
                  className={`${userStore.user.id === data.id ? 'text-black' : null} `}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <circle cx="12" cy="12" r="9" stroke="rgb(225, 96, 112)" strokeWidth="2" />
                  <path d="M18 18L6 6" stroke="rgb(225, 96, 112)" strokeWidth="2" />
                </svg>
              </button>
            )}
          </OverlayTrigger>
        </div>
      </div>
      <BanUserModal
        show={showBanModal}
        handleClose={() => setShowBanModal(false)}
        userId={data.id}
        onBan={onUpdate}
      />
    </div>
  );
};
